/** Modales (prompt / confirm / custom) + menu contextuel. */
import { el, onDismiss } from './dom.js';
import { icon } from './icons.js';

export function openModal(build) {
  // Évite que du texte reste sélectionné derrière la modale.
  try { window.getSelection && window.getSelection().removeAllRanges(); } catch {}
  const backdrop = el('div', { class: 'modal-backdrop' });
  const close = () => { backdrop.remove(); document.removeEventListener('keydown', esc); };
  const esc = (e) => { if (e.key === 'Escape') close(); };
  const modal = el('div', { class: 'modal', onclick: (e) => e.stopPropagation() });
  backdrop.appendChild(modal);
  backdrop.addEventListener('mousedown', (e) => { if (e.target === backdrop) close(); });
  document.addEventListener('keydown', esc);
  build(modal, close);
  document.body.appendChild(backdrop);
  return close;
}

export function promptModal({ title, label, value = '', placeholder = '', confirm = 'Valider' }) {
  return new Promise((resolve) => {
    openModal((modal, close) => {
      const input = el('input', { class: 'input', value, placeholder });
      const submit = () => { close(); resolve(input.value.trim() || null); };
      modal.append(
        el('h3', {}, title),
        label ? el('label', {}, label) : '',
        input,
        el('div', { class: 'row' },
          el('button', { class: 'btn btn-ghost', onclick: () => { close(); resolve(null); } }, 'Annuler'),
          el('button', { class: 'btn btn-primary', onclick: submit }, confirm)
        )
      );
      input.focus();
      input.select();
      input.addEventListener('keydown', (e) => { if (e.key === 'Enter') submit(); });
    });
  });
}

export function confirmModal({ title, message, confirm = 'Confirmer', danger = false }) {
  return new Promise((resolve) => {
    openModal((modal, close) => {
      modal.append(
        el('h3', {}, title),
        message ? el('p', { class: 'sub' }, message) : '',
        el('div', { class: 'row' },
          el('button', { class: 'btn btn-ghost', onclick: () => { close(); resolve(false); } }, 'Annuler'),
          el('button', {
            class: 'btn ' + (danger ? 'btn-primary' : 'btn-primary'),
            style: danger ? { background: 'linear-gradient(180deg,#ff6b6b,#e23d3d)', boxShadow: 'none' } : {},
            onclick: () => { close(); resolve(true); },
          }, confirm)
        )
      );
    });
  });
}

/** Menu contextuel positionné à (x, y). items: {label, icon, onClick, danger} | {sep:true} */
export function contextMenu(x, y, items) {
  document.querySelectorAll('.menu').forEach((m) => m.remove());
  const menu = el('div', { class: 'menu' });
  for (const it of items) {
    if (!it) continue;
    if (it.sep) { menu.appendChild(el('div', { class: 'menu-sep' })); continue; }
    const row = el('div', { class: 'menu-item' + (it.danger ? ' danger' : '') },
      el('span', { html: icon(it.icon || 'chevron', 17) }), it.label);
    row.addEventListener('click', () => { close(); it.onClick && it.onClick(); });
    menu.appendChild(row);
  }
  document.body.appendChild(menu);
  // repositionne dans le viewport
  const r = menu.getBoundingClientRect();
  menu.style.left = Math.min(x, innerWidth - r.width - 10) + 'px';
  menu.style.top = Math.min(y, innerHeight - r.height - 10) + 'px';
  const dismiss = onDismiss(menu, () => menu.remove());
  function close() { dismiss(); menu.remove(); }
  return close;
}
